import Component from 'flarum/common/Component';
import clsx from 'flarum/common/utils/classList';
export default class Label extends Component {
  view(vnode) {
    const {
      color,
      className
    } = this.attrs;
    return m("span", {
      className: clsx('UiKit-Label', className, {
        colored: !!color
      }),
      style: color ? {
        backgroundColor: `#${color}`
      } : undefined
    }, m("span", {
      className: "UiKit-Label-text"
    }, vnode.children));
  }
}
flarum.reg.add('fof-ui-kit', 'common/components/Label', Label);